import shuffle from 'lodash/shuffle'
import {isSuperValid} from './super-paths/validate-supers.js'

export function getBotSuperDecision(casterModel, teamCombatants=[], enemyCombatants=[], supers=[]) {

  //randomize them.
  const shuffledSupers = shuffle([...supers]);

  //Find a valid one (all will be tried until valid one is found)
  const validSuper = getValidSuperFromSeries(shuffledSupers, teamCombatants, enemyCombatants, casterModel);
  if (validSuper) {
    //This one is valid! Get targets and return the info
    return {
      actionModel: validSuper,
      casterModel,
      targetModels: getTargetsFromSuper(validSuper.targetType, teamCombatants, enemyCombatants)
    }
  }

  //if no solution (no valid supers), keep going on to the usual paths (doesn't take up any `personalitySmartAttempts`)
  return null;
}


function getValidSuperFromSeries(chain=[], teamCombatants, enemyCombatants, casterModel) { //recursive

  if (!chain.length) {
    //No options in the chain are valid.
    return null
  }

  if (isSuperValid(chain[0].id, teamCombatants, enemyCombatants, casterModel)) {

    // console.log('chosen Super', chain[0]);
    //Return the actionModel
    return chain[0];
  }

  //if not successful.. recursively try again
 return getValidSuperFromSeries(
   chain.filter((d,i) => i !== 0 ), //remove the first item that was tried
   teamCombatants, //pass in the same other properties
   enemyCombatants,
   casterModel
 );

}

function getTargetsFromSuper(targetType="", teamCombatants, enemyCombatants) {

  if (targetType === "all") {
    return [...teamCombatants, ...enemyCombatants];
  }
  if (targetType === "ally-team") {
    return [...teamCombatants];
  }
  if (targetType === "opponent-team") {
    return [...enemyCombatants];
  }
  //TODO: no supers target individuals yet

  console.warn('no target found in `getTargetsFromSuper`', targetType);
  return []
}




// WEBPACK FOOTER //
// ./src/battle/bot-decisions/get-bot-super-decision.js